




























































































import { snakeCase } from 'lodash'
import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../Pi'
import { InactiveInput } from '../../../../../../components'
import CustomEditor from '../../../../../Editor/CustomEditor'
import ProxySendMessageAction from '../../logic/Proxy/actions/ProxySendMessageAction'
import ProxyTypingAction from '../../logic/Proxy/actions/ProxyTypingAction'
import ProxyUserInputAction from '../../logic/Proxy/actions/ProxyUserInputAction'
import { SendMessageNode } from '../../logic/SendMessageNode'
import { MessageNodeActionTypes } from '../../logic/types'
import MessageAction from './components/MessageAction.vue'
import SendMessageAddNewActionModal from './components/SendMessageAddNewActionModal.vue'
import TypingAction from './components/TypingAction.vue'
import UserInputAction from './components/UserInputAction.vue'

@Component({
  data() {
    return {
      ProxySendMessageAction,
      ProxyTypingAction,
      ProxyUserInputAction,
      snakeCase,
    }
  },
  components: {
    InactiveInput,
    MessageAction,
    SendMessageAddNewActionModal,
    TypingAction,
    UserInputAction,
  }
})
export default class SendMessageSidebar extends UseFields {
  @Prop() node!: SendMessageNode

  @Prop() editor!: CustomEditor

  addNewActionIsOpen = false

  get placeholders() {
    if (typeof this.node.nodeProps.placeholders === 'function') {
      return this.node.nodeProps.placeholders()
    }

    return []
  }

  get inactiveTime(): number {
    return this.node.data.inactive_action.time
  }

  set inactiveTime(time: number) {
    this.node.data.setInactiveTime(time)
  }

  getPrevTypingAction(index: number): ProxyTypingAction | null {
    const action = this.node.data.proxyActions[index - 1]

    if (action instanceof ProxyTypingAction) {
      return action
    }

    return null
  }

  createNewAction(type: MessageNodeActionTypes): void {
    this.node.createNewAction(type)
    this.addNewActionIsOpen = false
  }
}
